import { IPatient, v2, constants } from '../../..';
import { contactRecordAdapter } from './contactRecord.adapter';
import { getDefaults } from './helpers/getDefaults';

export const contactReferenceAdapter = (job: IPatient): v2.ContactReference[] => {
    const contactRecords = contactRecordAdapter(job);
    const defaults = getDefaults(job);

    return contactRecords.map((contactRecord) => ({
        ...defaults,
        id: contactRecord.id,
        contactRecordId: constants.NOT_CAPTURED,
        contactRecord,
    }));
};
